import { useState, useCallback } from 'react';

export type DrillLevel = {
  level: number;          // 0 = root
  label: string;          // breadcrumb label
  key?: string;           // selected key (location, chamber, customer ...)
};

export function useDrillStack(rootLabel: string) {
  const [stack, setStack] = useState<DrillLevel[]>([{ level: 0, label: rootLabel }]);

  const drillInto = useCallback((next: DrillLevel) => {
    setStack(prev => [...prev, next]);
  }, []);

  const drillBack = useCallback(() => {
    setStack(prev => (prev.length > 1 ? prev.slice(0, -1) : prev));
  }, []);

  const drillTo = useCallback((level: number) => {
    setStack(prev => prev.slice(0, level + 1));
  }, []);

  const reset = useCallback(() => setStack([{ level: 0, label: rootLabel }]), [rootLabel]);

  const current = stack[stack.length - 1];
  return { stack, current, drillInto, drillBack, drillTo, reset };
}
